.avatar-with-exchange {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.avatar-with-exchange .holder {
  color: var(--lab-ds-semantic-color-bg-default);
}

.overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-pill);
  background-color: var(--lab-ds-semantic-color-fg-default);
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.exchange-icon {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.avatar-with-exchange:hover:not(.disabled) .overlay {
  opacity: var(--lab-ds-core-opacity-80);
}

.avatar-with-exchange:hover:not(.disabled) .exchange-icon {
  opacity: 1;
  color: var(--lab-ds-semantic-color-bg-default);
}

.avatar-with-exchange:active:not(.disabled) .overlay {
  opacity: var(--lab-ds-core-opacity-80);
}

.avatar-with-exchange:active:not(.disabled) .exchange-icon {
  opacity: 1;
  color: var(--lab-ds-semantic-color-bg-cloudy);
}
